{% block scop_platform_redirect_list %}

    <sw-page class="scop-platform-redirect-list">
        <template #search-bar>
            <sw-search-bar
                    initial-search-type="scop_platform_redirecter_redirect"
                    :initial-search="term"
                    @search="onSearch"
            />
        </template>

        <template #smart-bar-actions>
            {% block scop_platform_redirect_list_smarbar %}
                <mt-button variant="primary" @click="$router.push({name: 'scop.platform.redirect.create'})">
                    {{ $t('scopplatformredirecter.list.createButton') }}
                </mt-button>
                <mt-button variant="secondary" @click="onClickExport" :isLoading="exportLoading" :disabled="noRedirect">
                    {{ $t('scopplatformredirecter.list.exportAllButton') }}
                </mt-button>
                <mt-button variant="secondary" @click="onClickImport">
                    {{ $t('scopplatformredirecter.list.importButton') }}
                </mt-button>
                <mt-button v-if="inAppActive" variant="secondary" @click="$router.push({name: 'scop.platform.redirect.notFoundLog'})">
                    {{ $t('scopplatformredirecter.list.show404Button') }}
                    <span v-if="openNotFoundCount > 0" class="scop-platform-redirect-list__not-found-badge">{{ openNotFoundCount }}</span>
                </mt-button>
                <!-- <mt-button v-if="inAppActive" variant="secondary" @click="onClickCheckLinks">
                    {{ $t('scopplatformredirecter.list.check404') }}
                </mt-button> -->
                <mt-button class="mt-external-link" variant="action" :link="$tc('scopplatformredirecter.list.faqButton.link')">
                    {{ $t('scopplatformredirecter.list.faqButton.text') }} <sw-icon name="regular-external-link" small="true"/>
                </mt-button>
                <mt-button v-if="hideButton" variant="primary" @click="onClickIap">
                    {{ $t('scopplatformredirecter.list.iap') }}
                </mt-button>
            {% endblock %}
        </template>
        <template #content>
            {% block scop_platform_redirect_list_search_iap_block %}
                <mt-banner v-if="searchBlocked" variant="attention" style="margin: 24px;">
                    <p>{{ $tc('scopplatformredirecter.list.searchIapRequired') }}</p>
                    <mt-button variant="primary" size="small" @click="onClickIap">
                        {{ $t('scopplatformredirecter.list.iap') }}
                    </mt-button>
                </mt-banner>
            {% endblock %}
            {% block scop_platform_redirect_list_content %}
                <sw-entity-listing
                        v-if="entitySearchable && !searchBlocked"
                        ref="listing"
                        :items="redirect"
                        :repository="redirectRepository"
                        :columns="columns"
                        detailRoute="scop.platform.redirect.details"
                        :is-loading="isLoading"
                        identifier="scop-platform-redirect-list"
                        @update-records="updateTotal"
                        :sort-by="sortBy"
                        :sort-direction="sortDirection"
                        @inline-edit-save="onInlineEditSave"
                >
                    <template #column-sourceURL="{ item }">
                        <router-link :to="{ name: 'scop.platform.redirect.details', params: { id: item.id } }">
                            {{ item.sourceURL }}
                        </router-link>
                        <sw-label v-if="item.productId" variant="info" appearance="pill" size="medium" style="margin-left: 8px;">
                            {{ $tc('scopplatformredirecter.list.autoCreated') }}
                        </sw-label>
                    </template>
                    <template #column-targetURL="{ item }">
                        <template v-if="item.targetEntityType">
                            <sw-label variant="info" appearance="pill" size="medium">
                                {{ $tc('scopplatformredirecter.list.targetEntityLabel.' + item.targetEntityType) }}
                            </sw-label>
                            <span v-if="item.targetURL" style="margin-left: 8px;">{{ item.targetURL }}</span>
                        </template>
                        <template v-else>
                            {{ item.targetURL }}
                        </template>
                    </template>
                    <template #column-queryParamsHandling="{ item }">
                        {{ $tc('scopplatformredirecter.list.queryParamsHandlingValues.' + item.queryParamsHandling) }}
                    </template>
                    <template #column-salesChannel="{ item }">
                        {{ item.salesChannel ? item.salesChannel.translated.name : $tc('scopplatformredirecter.list.allSalesChannels') }}
                    </template>
                    <template #column-createdAt="{ item }">
                        {{ formatDate(item.createdAt) }}
                    </template>
                </sw-entity-listing>
            {% endblock %}
            {% block scop_platform_redirect_list_view_import_modal %}
                <scop-platform-redirect-import-export-modal
                        :show="showImportExportModal"
                        :type="modalType"
                        @close="closeImportExport"
                        @updateList="updateList"
                >
                </scop-platform-redirect-import-export-modal>
            {% endblock %}
        </template>
    </sw-page>
{% endblock %}
